
import {
    FETCHED_FAQS,
    FETCHED_FAQ,
    FETCH_FAQS_TYPES,
    CREATED_FAQ,
    UPDATED_FAQ,
    DELETED_FAQ,
    FETCHED_FAQS_TRANSLATIONS,
    FETCHED_FAQ_TRANSLATION,
    CREATED_FAQ_TRANSLATION,
    UPDATED_FAQ_TRANSLATION,
    DELETED_FAQ_TRANSLATION,
    FETCHED_FAQS_BY_SEARCH_TERMS,
    CLEAR_FAQS_SEARCH_FILTER
} from './types';

export function fetchedFaqs(data, totalPages) {
    return {
        type: FETCHED_FAQS,
        payload: {
            data: data,
            totalPages: totalPages
        }
    }
}

export function fetchedFaq(faq) {
    return {
        type: FETCHED_FAQ,
        faq
    };
}

export function fetchedFaqsTypes(faqsTypes) {
    return {
        type: FETCH_FAQS_TYPES,
        faqsTypes
    }
}

export function createdFaq(response) {
    return {
        type: CREATED_FAQ,
        response
    }
}

export function updatedFaq(faq) {
    return {
        type: UPDATED_FAQ,
        faq
    }
}

export function deletedFaq(faqId) {
    return {
        type: DELETED_FAQ,
        faqId
    }
}

export function fetchedFaqsTranslations(faqsTranslations) {
    return {
        type: FETCHED_FAQS_TRANSLATIONS,
        faqsTranslations
    }
}

export function fetchedFaqTranslation(faqTranslation) {
    return {
        type: FETCHED_FAQ_TRANSLATION,
        faqTranslation
    };
}

export function createdFaqTranslation(faqTranslation) {
    return {
        type: CREATED_FAQ_TRANSLATION,
        faqTranslation
    }
}

export function updatedFaqTranslation(faqTranslation) {
    return {
        type: UPDATED_FAQ_TRANSLATION,
        faqTranslation
    }
}

export function deletedFaqTranslation(translationId) {
    return {
        type: DELETED_FAQ_TRANSLATION,
        translationId
    }
}


export function gotFaqsBySearchTerms(faqs) {
    return {
        type: FETCHED_FAQS_BY_SEARCH_TERMS,
        payload: faqs
    }
}

export function clearFaqsSearchFilter() {
    return {
        type: CLEAR_FAQS_SEARCH_FILTER,
    }
}


// WEBPACK FOOTER //
// ./src/containers/faqs/actions.js